import React, { useContext, useEffect, useState, useCallback } from "react";
import OrderContext from "../../../../context/OrderContext";
import Loader from "../../../Loader/Loader";
import moment from "moment";
import $ from "jquery";
import AuthContext from "../../../../context/AuthContext";

const ModalDetails = () => {
  let { user } = useContext(AuthContext);

  let {
    orderData,
    getOrderDataID,
    priceSum,
    orderID,
    loader,
    closeModal,
    setConfirmReturn,
    confirmReturn,
    availabilityProductConfirm,
    toRetuen,
    productReturn,
    setOrderData,
  } = useContext(OrderContext);

  useEffect(() => {
    getOrderDataID(orderID);
  }, []);

  function handleProductConfirm() {
    const productAvailabilityArray = [];
    let ids = $.map($(".product-status"), function (elt) {
      const id = $(elt).attr("data-item");
      const val = $("input[name=" + id + "-radio]:checked").val();
      const item = { item: `${id}`, value: val };
      productAvailabilityArray.push(item);
    });

    const buble = document.getElementById(
      `stoct-check-${orderData.data.orderId}`
    );
    productAvailabilityArray.find((i) => i.value === "not_available")
      ? buble.classList.add("danger")
      : buble.classList.add("success");
    buble.classList.add("bounce");

    const thisrow = document.getElementById(
      `${orderData.data.orderId}-element`
    );
    thisrow.classList.add("hidden");

    // buble.classList.add("success");

    availabilityProductConfirm(
      productAvailabilityArray,
      orderData.data.orderId
    );
  }

  function handleCinfirm(param, qty, orderID, itemId) {
    setConfirmReturn(param);
    if (param) {
      toRetuen.push(qty, orderID, itemId);
    }
  }

  function handleContinueReturn() {
    let qty = toRetuen[0];
    let id = toRetuen[1];
    let orderId = toRetuen[2];
    productReturn(qty, id, orderId);
  }

  return (
    <>
      <div className="modal-header">
        <h4 className="modal-title">Details</h4>
        <button onClick={closeModal} className="btn btn-close">
          <i className="feather icon-x"></i>
        </button>
      </div>

      {loader ? (
        <Loader></Loader>
      ) : (
        <div className="modal-content">
          <div className="row invoive-info mt-4 mb-4">
            <div className="col-md-4 col-xs-12 invoice-client-info ml-3">
              <h3>Biling Address</h3>

              <h6 className="mb-10">{orderData.data.customer.shipping.name}</h6>
              <p className="m-0 m t-10">
                {orderData.data.customer.shipping.street},
                {orderData.data.customer.shipping.city},{" "}
                {orderData.data.customer.shipping.postalCode},{" "}
                {orderData.data.customer.shipping.country}{" "}
              </p>
              <p className="m-0">
                {" "}
                {orderData.data.customer.shipping.phoneNumber}{" "}
              </p>
            </div>
            {/* <div className="col-md-4 col-xs-12 invoice-client-info"> 
                            <h3>Shipping Address</h3>
                            <h6 className="mb-10">{orderData.data.customer.shipping.name}</h6>
                            <p className="m-0 m t-10">{orderData.data.customer.shipping.street},{orderData.data.customer.shipping.city}, {orderData.data.customer.shipping.postalCode}, {orderData.data.customer.shipping.country} </p>
                            <p className="m-0"> {orderData.data.customer.shipping.phoneNumber} </p>  
                        </div> */}
            <div className="col-md-3 col-xs-12 invoice-client-info">
              <h6 className="mb-2">
                Order Id <span>#{orderData.data.orderId}</span>
              </h6>
              <p className="mb-10">
                {" "}
                Date: {moment(orderData.data.saleTime).format("MMM Do YY")}{" "}
              </p>
              <p className="mb-10">
                {user.roles.includes("ROLE_all-seeing") && (
                  <a
                    href={`https://www.mybudapester.com/index.php/$budaAdminPanel$/sales_order/view/order_id/${orderData.data.magentoInternalId}/key/8706d457467a1ea14876867b5d185d20/`}
                    target="_blank"
                    type="button"
                    className="btn btn-orange"
                  >
                    Go to Magento{" "}
                  </a>
                )}
              </p>
            </div>

            <table className="table table-striped nowrap">
              <thead>
                <tr>
                  <th></th>
                  <th>Info</th>
                  <th>Size</th>
                  <th>SKU</th>
                  <th>Ean</th>
                  <th>Id</th>
                  <th>Price</th>
                  <th>Availability</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {orderData.data.products.map((item) => (
                  <tr
                    key={item.id}
                    id={`row-id-${item.id}`}
                    className={item.returned ? "returned" : ""}
                  >
                    <td>
                      <div className="thumb ml-4">
                        <img
                          className="img-table-thumb"
                          src={item.thumbUrl}
                          alt={item.name}
                        />
                      </div>
                    </td>
                    <td className="product-info">
                      <span className="tex-bold">
                        {item.brand.name}{" "}
                        <b className="pcoded-badge label label-danger bages">
                          Returned
                        </b>{" "}
                      </span>{" "}
                      <p>
                        {item.name}
                        <br /> {item.qty}x{" "}
                      </p>{" "}
                    </td>
                    <td>{item.size != null ? item.size : "-"}</td>
                    <td>{item.sku}</td>
                    <td>{item.ean}</td>
                    <td>{item.id}</td>

                    <td>
                      {item.price.value} {item.price.currency}
                    </td>

                    <td>
                      {orderData?.data.vendorAwareStatus === "awaiting" ? (
                        <form
                          className="check-radio product-status"
                          data-item={item.id}
                        >
                          <div className="form-group">
                            <label className="form-control yes">
                              <input
                                type="radio"
                                name={`${item.id}-radio`}
                                defaultChecked={
                                  item.availability === "unknown" ||
                                  item.availability === "ok"
                                    ? "checked"
                                    : ""
                                }
                                value="ok"
                              />
                            </label>
                          </div>
                          <div className="form-group">
                            <label className="form-control no">
                              <input
                                type="radio"
                                defaultChecked={
                                  item.availability === "unknown" ||
                                  item.availability === "not_available "
                                    ? "checked"
                                    : ""
                                }
                                name={`${item.id}-radio`}
                                value="not_available"
                              />
                            </label>
                          </div>
                        </form>
                      ) : (
                        <>
                          {item.availability === "unknown" ||
                          item.availability === "ok" ? (
                            <span className="pcoded-badge label label-success">
                              available
                            </span>
                          ) : (
                            ""
                          )}
                          {item.availability === "not_available" ||
                          item.availability === "not_available " ? (
                            <span className="pcoded-badge label label-danger">
                              not available
                            </span>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    </td>
                    {orderData?.data.vendorAwareStatus != "awaiting" ? (
                      <td>
                        {!item.returned ? (
                          <form className="return-form">
                            <div className="return-form-component">
                              <input
                                type="number"
                                className="form-control"
                                name="qty"
                                min="1"
                                max={item.qty}
                                placeholder="1"
                              />
                              <button
                                type="button"
                                className="btn btn-orange"
                                onClick={() =>
                                  handleCinfirm(
                                    true,
                                    item.qty,
                                    orderData.data.orderId,
                                    item.id
                                  )
                                }
                              >
                                Return
                              </button>
                            </div>
                          </form>
                        ) : (
                          ""
                        )}
                      </td>
                    ) : (
                      ""
                    )}
                  </tr>
                ))}

                {orderData.data?.vendorAwareStatus === "awaiting" ? (
                  <tr>
                    <td colSpan={6}></td>
                    <td>
                      {" "}
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          handleProductConfirm();
                        }}
                      >
                        Confirm Stock
                      </button>
                    </td>
                  </tr>
                ) : (
                  ""
                )}
              </tbody>
            </table>

            <div className="order-total">
              <h3>
                <span>Total: </span> {priceSum}{" "}
                <b>{orderData.data.sum.currency}</b>
              </h3>
            </div>
          </div>

          {confirmReturn && orderData.data.vendorAwareStatus != "awaiting" ? (
            <div className="modal-confirm-overley">
              <div className="modal-confirm">
                <button
                  className="btn btn-close"
                  onClick={() => handleCinfirm(false)}
                >
                  <i className="feather icon-x"></i>
                </button>
                <h4 className="modal-title">Are you sure?</h4>
                <div>
                  <button
                    className="btn btn-primary"
                    onClick={() => handleContinueReturn()}
                  >
                    Yes! Continue.
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => handleCinfirm(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      )}
    </>
  );
};

export default ModalDetails;
